import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Carousel from 'react-bootstrap/Carousel';
import Swipe from '../assets/ico-swipe-ep.svg';
import Options from '../assets/ico-options-menu-ep.svg';
import Landscape from '../assets/ico-landscape-ep.svg';
import Scroll from '../assets/ico-scroll-ep.svg';
import Tabs from '../assets/ico-tabs-ep.svg';
import Resource from '../assets/ico-resource-ep.svg';
import Button from 'react-bootstrap/Button';

class Help extends Component {
    render() {     
        if (this.props.brand === "EP") {
            return (
                <Modal show={this.props.show}
                    backdrop="static"
                    className="EP"
                    >
                    <div className="EP modal-view">
                                <Modal.Body>
                                    <div className="help-radius-control">
                                        <Carousel
                                            interval={9000000}
                                            controls = {false}
                                        >
                                            <Carousel.Item>
                                                <div>
                                                    <div className="help-row">
                                                        <img className="help-icon" src={Options} alt="" height="24" width="24"></img>
                                                        <p>
                                                            This document is in mobile
                                                            mode. To view it in desktop
                                                            mode or to print, tap on the
                                                            options menu.
                                                        </p>
                                                    </div>

                                                    <div className="help-row">
                                                        <img className="help-icon" src={Landscape} alt="" ></img>
                                                        <p>
                                                            <span className="highlight-EP-span">For the best experience, </span>
                                                            open the link in a browser
                                                            and hold your device in
                                                            landscape orientation.
                                                        </p>
                                                    </div>
                                                    
                                                    <div className="help-row">
                                                        <img className="help-icon" src={Swipe} alt="" ></img>
                                                        <p>
                                                            Use the arrow buttons or
                                                            swipe to move between
                                                            questions.
                                                        </p>
                                                    </div>
                                                </div>
                                            </Carousel.Item>

                                            <Carousel.Item>
                                                <div className="horizontal-help">
                                            <div className="table-help-text help-landscape-spacing">
                                                <p>
                                                    <span className="highlight-EP-span" >Note:  </span> some features (e.g. tables) are
                                                    wider than the screen, especially in
                                                    portrait orientation.

                                                    Touch and drag to view them fully.
                                                </p>
                                            </div>
                                                    
                                            <div className="table-help-image help-landscape-spacing">
                                                        <img className="table-help-img" src={require("../images/table-img.PNG")} alt=""></img>
                                                        <img className="help-icon help-icon-table" src={Scroll} alt="" ></img>
                                                    </div>
                                                </div>
                                            </Carousel.Item>

                                            <Carousel.Item>
                                                <div className="horizontal-help">
                                                    <div className="horizontal-help-column help-landscape-spacing">
                                                        <p>
                                                            Use the menu at the bottom of the
                                                            screen to view mark schemes,
                                                            examiner remarks, notes and
                                                            resources when they are available.
                                                        </p>
                                                <img className="navbar-img-help" src={Tabs} alt=""></img>
                                                    </div>
                                                    
                                            <div className="help-row help-landscape-spacing">
                                                <img className="help-icon" src={Resource} alt=""></img>
                                                        <p>
                                                    <span className="highlight-EP-span" >Note:  </span> Some questions include audio clips as resources. 
                                                        Tap on menu items after pressing play on the audio 
                                                        player and playback will continue while you look 
                                                        at other question elements.
                                                        </p>
                                                    </div>
                                                </div>
                                            </Carousel.Item>
                                        </Carousel>
                                    </div>
                                </Modal.Body>
                                <div className="modal-footer-edit">
                                    <div className="modal-footer-checkbox">
                                        <Modal.Footer>
                                            <input 
                                                id="dontShowAgain"
                                                type="checkbox"
                                                className="dontShow"
                                            />
                                            Don't show again
                                            
                                        </Modal.Footer>
                                    </div>
                                    
                                    <div className="modalClose-EP" onClick={this.props.closeModal}>
                                        Close
                                    </div>
                                </div>
                </div>
            </Modal>
            )
        } else {
            return (
                <Modal show={this.props.show}
                    backdrop="static"
                    className="TB"
                    >
                    <div className="TB modal-view">
                                <Modal.Body>
                                    <Carousel
                                        interval="9000000"
                                        controls = {false}
                                    >
                                        <Carousel.Item>
                                            <div>
                                                <div className="help-row">
                                                    <img className="help-icon" src={require("../assets/ico-options-menu-tb.svg")} alt=""></img>
                                                    <p>
                                                        This document is in mobile
                                                        mode. To view it in desktop
                                                        mode or to print, tap on the
                                                        options menu.
                                                    </p>
                                                </div>

                                                <div className="help-row">
                                            <img className="help-icon" src={require("../assets/ico-landscape-tb.svg")} alt=""></img>
                                                    <p>
                                                        <span className="highlight-TB-span">For the best experience, </span>
                                                        open the link in a browser
                                                        and hold your device in
                                                        landscape orientation.
                                                    </p>
                                                </div>
                                                
                                                <div className="help-row">
                                            <img className="help-icon" src={require("../assets/ico-swipe-tb.svg")} alt=""></img>
                                                    <p>
                                                        Use the arrow buttons or
                                                        swipe to move between
                                                        questions.
                                                    </p>
                                                </div>
                                            </div>
                                        </Carousel.Item>

                                        <Carousel.Item>
                                            <div className="horizontal-help">
                                        <div className="table-help-text help-landscape-spacing">
                                                    <p>
                                                        <span className="highlight-TB-span" >Note:  </span> some features (e.g. tables) are
                                                        wider than the screen, especially in
                                                        portrait orientation.

                                                        Touch and drag to view them fully.
                                                    </p>
                                                </div>
                                                
                                        <div className="table-help-image help-landscape-spacing">
                                                    <img className="table-help-img" src={require("../images/table-img.PNG")} alt=""></img>
                                                    <img  className="help-icon help-icon-table" src={require("../assets/ico-scroll-tb.svg")} alt="" height="55" width="55"></img>
                                                </div>
                                            </div>
                                        </Carousel.Item>

                                        <Carousel.Item>
                                            <div className="horizontal-help">
                                        <div className="horizontal-help-column help-landscape-spacing">
                                                    <p>
                                                        Use the menu at the bottom of the
                                                        screen to view mark schemes,
                                                        examiner remarks, notes and
                                                        resources when they are available.
                                                    </p>
                                                    <img className="navbar-img-help" src={require("../assets/ico-tabs-ep.svg")} alt=""></img>
                                                </div>
                                                
                                        <div className="help-row help-landscape-spacing">
                                            <img className="help-icon" src={require("../assets/ico-resource-tb.svg")} alt=""></img>
                                                    <p>
                                                <span className="highlight-TB-span" >Note:  </span>Some questions include audio clips as resources. 
                                                        Tap on menu items after pressing play on the audio 
                                                        player and playback will continue while you look 
                                                        at other question elements.
                                                    </p>
                                                </div>
                                            </div>
                                        </Carousel.Item>
                                    </Carousel>
                                </Modal.Body>
                                <div className="modal-footer-edit">
                                    <div className="modal-footer-checkbox">
                                        <Modal.Footer>
                                            <input 
                                                id="dontShowAgain"
                                                type="checkbox"
                                            />
                                            Don't show again
                                            
                                        </Modal.Footer>
                                    </div>
                                    
                                    <div className="modalClose-TB" onClick={this.props.closeModal}>
                                    Close
                                    </div>
                                </div>

                </div>
            </Modal>
            )
        }
    }
}

export default Help;